<template>
  <div id="app" :style="cssProps">
    <v-app class="text-xs-left white--text scrollable">
      <v-content style="width: 100%;" v-if="!state.firstLoad">
        <v-container fluid fill-height justify-center align-center>
          <v-progress-circular indeterminate color="secondary" />
        </v-container>
      </v-content>
      <v-content style="width: 100%;" v-else>
        <v-toolbar :height="$vuetify.breakpoint.mdAndUp ? 90 : null" prominent color="transparent" style="width: 100%; box-shadow: none;" class="position-relative">
          <title-with-button :slot="$vuetify.breakpoint.xsOnly ? 'extension' : 'default'" class="white--text mt-2" v-if="$route.name === routeNames.REFUND" :action="() => { state.currentStep === 1 ? $router.push({ name: routeNames.MAIN }) : $store.commit('setStep', state.currentStep - 1)}" :title="$t(`steps.title.${state.currentStep}`)" :subtitle="$t('steps.of', { current: state.currentStep, total: 3 })" />
          <v-spacer />
          <img :src="configuration.configuration && configuration.configuration.logo ? configuration.configuration.logo : '/logo.png'" style="max-width: 200px !important; max-height: 100% !important;" class="ma-1" />
          <v-spacer v-if="$vuetify.breakpoint.xsOnly" />
        </v-toolbar>
        <v-container fluid fill-height style="max-width: 800px;" :class="{'pt-5': $vuetify.breakpoint.mdAndUp, 'py-1': $vuetify.breakpoint.xsOnly}">
          <v-layout justify-start align-start row wrap>
            <v-fade-transition>
              <v-icon v-if="showArrow && !hideArrow" style="position: fixed; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 100;" large color="white">keyboard_arrow_down</v-icon>
            </v-fade-transition>
            <v-slide-x-transition mode="out-in">
              <router-view class="overflow-y"/>
            </v-slide-x-transition>
          </v-layout>
        </v-container>
      </v-content>
      <v-snackbar v-if="state.message.show" multi-line :timeout="state.message.timeout" :color="state.message.color" v-model="state.message.show">
        {{ state.message.text }}
        <v-btn :loading="state.loading" :name="$t('message.close')" icon dark flat @click.native="state.message.show = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import routeNames from '@/router/route-names'
import ResponsivityMixins from '@/mixins/Responsivity'
export default {
  data () {
    return {
      routeNames
    }
  },
  components: {
    TitleWithButton: () => import('@/components/TitleWithButton.vue')
  },
  mixins: [
    ResponsivityMixins
  ],
  computed: {
    ...mapState(['state', 'configuration']),
    cssProps () {
      return {
        '--primary-color': this.$vuetify.theme.primary,
        '--secondary-color': this.$vuetify.theme.secondary,
        '--background-start': '#787878cc',
        '--background-end': '#e2e2e2'
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.configuration.instanceId) {
        this.$store.dispatch('getConfiguration').then((configuration) => {
          if (this.$route.name === routeNames.REFUND && !configuration.refundAvailable) {
            this.$router.push({ name: routeNames.MAIN, params: { instance: this.configuration.instanceId } })
          }
        }).catch((error) => {
          if (error.status === 404 || error.status === 502) {
            this.$router.push({ name: routeNames.NOT_FOUND })
          }
        })
      } else {
        this.$store.commit('setFirstLoad')
      }
    })
  }
}
</script>

<style lang="scss">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active  {
  -webkit-box-shadow: 0 0 0 30px rgba(102, 163, 177, 0.45) inset !important;
  box-shadow: 0 0 0 30px rgba(102, 163, 177, 0.45) inset !important;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
input:-internal-autofill-selected {
  -webkit-box-shadow: 0 0 0 30px rgba(102, 163, 177, 0.45) inset !important;
  box-shadow: 0 0 0 30px rgba(102, 163, 177, 0.45) inset !important;
  margin-top: 28px !important;
  height: 25px !important;
}
.scrollable {
  overflow-y: auto;
  scrollbar-width: none !important;
  flex: 1;
}
.overflow-y {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none !important;
}
.float-left {
  left: 0;
}
.float-right {
  left: 100%;
  transform: translateX(-130%);
}
.animate-position {
  transition: all 0.5s ease-in-out;
}
.position-relative {
  position: relative;
}
::-webkit-scrollbar {
  display: none;
}
body {
  scrollbar-width: none;
}
::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
  background: transparent; /* optional: just make scrollbar invisible */
}
html {
  -ms-overflow-style: none; // IE 10+
  overflow: -moz-scrollbars-none; // Firefox
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.v-content {
  .v-content__wrap {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: unset;
    overflow: auto;
  }
}

.v-content__wrap {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: unset;
}
.v-toolbar__content {
  min-height: fit-content;
}

.application--wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.application {
  background-size: cover !important;
  background-image: var(--background-start), url("assets/triangle_background.png") !important; /* Old browsers */
  background-image: -moz-linear-gradient(
    -45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ) !important; /* FF3.6-15 */
  background-image: -webkit-linear-gradient(
    -45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ), url("assets/triangle_background.png") !important; /* Chrome10-25,Safari5.1-6 */
  background-image: linear-gradient(
    -45deg,
    var(--background-start) 0%,
    var(--background-end) 100%
  ), url("assets/triangle_background.png") !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=var(--background-start), endColorstr=var(--background-end),GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
  background-blend-mode: overlay !important;
  background-color: var(--primary-color) !important;
}

.container.grid-list-xl, .container.grid-list-md {
  & .layout {
    margin: 0 !important;
  }
}

.flex-item {
  display: flex;
  &.row {
    flex-direction: row;
  }
  &.column {
    flex-direction: column;
  }
}
.flex-none {
  flex: none !important;
}

.v-btn.multiple-lines {
  min-height: fit-content;
  padding: 10px;
  & .v-btn__content {
    white-space: pre-wrap;
    margin-top: auto;
    margin-bottom: auto;
  }
}

@media screen
  and (orientation: landscape) {
  .logo {
    right: 0;
    right: 15px;
  }
}
@media screen
  and (orientation: portrait) {
  .logo {
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
